import { useState } from "react";
import SiteHeader from "../components/Header";
import Footer from "../components/Footer";
import SEO from "../components/SEO";

export default function EnquiryPage() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    guests: "",
    dates: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
    alert("Thank you for your enquiry! We will get back to you within 24 hours.");
  };

  return (
    <>
      <SEO 
        title="Enquiry"
        description="Plan your visit to Gawkari Hillside. Contact us to book your stay, get information about packages, or ask any questions."
      />
      <SiteHeader />
      <main>
        <section className="py-5">
          <div className="container" style={{maxWidth: '1000px'}}>
            <div className="text-center mb-5">
              <span className="badge bg-green-lt mb-2 p-2">Get in Touch</span>
              <h1 className="display-4 fw-bold mb-3 text-dark">Plan Your Gawkari Experience</h1>
              <p className="lead text-secondary mx-auto" style={{maxWidth: '600px'}}>
                Share your travel preferences and we'll craft the perfect itinerary for you
              </p>
            </div>

            <div className="row g-5">
              <div className="col-lg-8">
                <form className="card p-4 p-md-5" onSubmit={handleSubmit}>
                  <div className="row g-3">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label htmlFor="name" className="form-label">Your Name</label>
                        <input
                          type="text"
                          id="name"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          required
                          className="form-control"
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label htmlFor="email" className="form-label">Email Address</label>
                        <input
                          type="email"
                          id="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          required
                          className="form-control"
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label htmlFor="phone" className="form-label">Phone Number</label>
                        <input
                          type="tel"
                          id="phone"
                          name="phone"
                          value={formData.phone}
                          onChange={handleChange}
                          required
                          className="form-control"
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label htmlFor="guests" className="form-label">Number of Guests</label>
                        <select
                          id="guests"
                          name="guests"
                          value={formData.guests}
                          onChange={handleChange}
                          required
                          className="form-select"
                        >
                          <option value="">Select...</option>
                          <option value="1-2">1-2 guests</option>
                          <option value="3-5">3-5 guests</option>
                          <option value="6-10">6-10 guests</option>
                          <option value="10+">10+ guests</option>
                        </select>
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="mb-3">
                        <label htmlFor="dates" className="form-label">Preferred Dates</label>
                        <input
                          type="text"
                          id="dates"
                          name="dates"
                          placeholder="e.g., Jan 15-18, 2025"
                          value={formData.dates}
                          onChange={handleChange}
                          className="form-control"
                        />
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="mb-3">
                        <label htmlFor="message" className="form-label">Tell us about your trip</label>
                        <textarea
                          id="message"
                          name="message"
                          rows={4}
                          value={formData.message}
                          onChange={handleChange}
                          placeholder="Special requirements, interests, dietary preferences..."
                          className="form-control"
                        />
                      </div>
                    </div>

                    <div className="col-12">
                      <button type="submit" className="btn btn-primary w-100 btn-lg">
                        Send Enquiry
                      </button>
                    </div>
                  </div>
                </form>
              </div>

              <div className="col-lg-4">
                <div className="d-flex flex-column gap-4">
                  <div className="card p-4">
                    <h3 className="h4 mb-3">Contact Information</h3>
                    <ul className="list-unstyled d-flex flex-column gap-3 mb-0">
                      <li>
                        <strong>Phone:</strong><br/>
                        <a href="tel:+919284636553" className="text-decoration-none">+91 92846 36553</a>
                      </li>
                      <li>
                        <strong>Email:</strong><br/>
                        <a href="mailto:contact@gawkari.com" className="text-decoration-none">contact@gawkari.com</a>
                      </li>
                      <li>
                        <strong>Address:</strong><br/>
                        <span>At Satalewadi, Post Parkhandi, Satara, Maharashtra - 412803</span>
                      </li>
                    </ul>
                  </div>

                  <div className="card p-4 bg-primary-lt">
                    <h3 className="h4 mb-2">Quick Response</h3>
                    <p className="mb-0 text-secondary">Our hosts typically respond within 24 hours with a customized itinerary based on your preferences.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
